import { render, staticRenderFns } from "./initialReviewTable.vue?vue&type=template&id=48d13d96"
import script from "./initialReviewTable.vue?vue&type=script&lang=js"
export * from "./initialReviewTable.vue?vue&type=script&lang=js"
import style0 from "./initialReviewTable.vue?vue&type=style&index=0&id=48d13d96&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports